<template>
    <div v-if="isVisible" class="healthcheck-bar d-print-none" role="alert">
        <i class="siscont icon_warn healthcheck-bar__icon" />
        <p class="healthcheck-bar__text mb-0">
            Estamos com instabilidade de conexão com o Sankhya, algumas operações podem apresentar falha. A equipe de TI já foi notificada e segue com a tratativa do erro.
        </p>
    </div>
</template>

<script>
const POLLING_INTERVAL = 120000;

export default {
    name: "HealthcheckNotificationBar",
    data() {
        return {
            pollingInterval: null,
            lastCheckAt: 0
        };
    },
    computed: {
        isVisible() {
            return this.$store.getters.getLoggedIn === true && this.$store.getters.getSankhyaIsDown === true;
        }
    },
    methods: {
        startPolling() {
            this.stopPolling();
            this.check();
            this.pollingInterval = setInterval(this.check, POLLING_INTERVAL);
        },
        stopPolling() {
            if (this.pollingInterval) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
            }
        },
        // Aba em segundo plano não consulta: o aviso só importa para quem está vendo a tela.
        check() {
            if (document.hidden) {
                return;
            }
            this.lastCheckAt = Date.now();
            this.$store.dispatch('checkSankhyaHealth');
        },
        // Ao voltar para a aba, atualiza na hora se a última consulta já venceu.
        onVisibilityChange() {
            if (this.pollingInterval && Date.now() - this.lastCheckAt >= POLLING_INTERVAL) {
                this.check();
            }
        }
    },
    mounted() {
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        if (this.$store.getters.getLoggedIn === true) {
            this.startPolling();
        }
    },
    beforeUnmount() {
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.stopPolling();
    },
    watch: {
        '$store.getters.getLoggedIn'(val) {
            if (val) {
                this.startPolling();
            } else {
                this.stopPolling();
                this.$store.commit('setSankhyaIsDown', false);
            }
        }
    }
};
</script>

<style scoped>
.healthcheck-bar {
    /* O .top-header tem margin-bottom: 24px; o valor negativo cola a barra na base dele. */
    margin-top: -24px;
    margin-bottom: 24px;
    margin-left: var(--sidebar-mini-width);
    width: calc(100% - var(--sidebar-mini-width));
    padding: 18px 32px;
    display: flex;
    align-items: center;
    gap: 14px;
    background-color: #fff4e0;
    border-top: 1px solid #f5c983;
    border-bottom: 1px solid #f5c983;
    border-left: 5px solid #d97706;
    color: #7a4b00;
    position: relative;
    z-index: 999;
}

.healthcheck-bar__icon {
    font-size: 26px;
    color: #d97706;
    flex-shrink: 0;
}

.healthcheck-bar__text {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.45;
}

@media (max-width: 767px) {
    .healthcheck-bar {
        width: 100%;
        margin-left: 0;
        padding: 14px 16px;
        align-items: flex-start;
        gap: 10px;
    }

    .healthcheck-bar__icon {
        font-size: 20px;
    }

    .healthcheck-bar__text {
        font-size: 13px;
    }
}
</style>
